"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Features = void 0;
const Feature_1 = require("../Feature");
exports.Features = {
    create: (definition) => {
        const features = Object.entries(definition).reduce((features, [featureKey, actionDefinition]) => {
            return {
                ...features,
                [featureKey]: Feature_1.Feature.create(featureKey, actionDefinition),
            };
        }, {});
        return {
            ...features,
            getAllFeatures: () => {
                return Object.values(features);
            },
            getAllActions: () => {
                return Object.values(features).reduce((allActions, feature) => {
                    return [...allActions, ...Object.values(feature.actions)];
                }, []);
            },
        };
    },
};
